module.exports = "/images/ico-g-pay.svg?8610e41a1e4653c69502980e348699bf";